export enum PropertyAttributeName {
  HintText = "HintText", // Common
  HelpText = "HelpText", // Common
  Icon = "Icon", // Common
  Pattern = "pattern", // Text
  Min = "Min",
  Max = "Max",
  Step = "Step",
  Rows = "Rows",
  DefaultValue = "DefaultValue",
  Uppercase = "Uppercase",
  Lowercase = "Lowercase",
  Placeholder = "Placeholder",
  AcceptFileTypes = "AcceptFileTypes",
  MaxSize = "MaxSize",
  Editor = "editor",
  EditorLanguage = "EditorLanguage",
  EditorSize = "EditorSize",
  Columns = "Columns",
  Group = "Group",
  FormatNumber = "FormatNumber",
  FormatDate = "FormatDate",
  FormatBoolean = "FormatBoolean",
  Separator = "Separator",
  SelectOptions = "SelectOptions",
  Password = "Password",
}
